import React from "react";
import ReactDOM from "react-dom";
import { VetLoginMod } from '../scripts/VetLoginMod.js';
import ScriptWrapper from "./ScriptWrapper.tsx";

ReactDOM.render(
  <React.StrictMode>
    <ScriptWrapper>
      <VetLoginMod />
    </ScriptWrapper>
  </React.StrictMode>,
  document.getElementById("myhome")
);